/* unplugin-vue-components disabled */import script from "./BeiDanViewCompare.vue?vue&type=script&setup=true&lang=js"
export * from "./BeiDanViewCompare.vue?vue&type=script&setup=true&lang=js"

import "./BeiDanViewCompare.vue?vue&type=style&index=0&id=614f2af1&step=true&lang=css"

const __exports__ = script;

export default __exports__